export enum FORMAT_DATE {
    ddmmyyyy = 'DD-MM-YYYY',
    yyyymmdd = 'YYYY-MM-DD',
    yyyymmddhhmm = 'YYYY-MM-DD HH:mm',
    yyyymmddhhmmss = 'YYYYM-MM-DD HH:mm:ss',
    yyyymmddhhmmssZ = 'YYYY-MM-DDTHH:mm:ssZ',
    ddmmyyy_space = 'DD MM YYYY',
    ddmm = 'DD/MM',
    dd = 'DD',
}